// extracted by mini-css-extract-plugin
module.exports = {"container":"applied-filters_container__2YTou","phAnimation":"applied-filters_phAnimation__olKkc"};